import {Component, OnInit} from '@angular/core';
import {BoosterService} from "./services/booster.service";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../store";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'db-booster',
    templateUrl: './booster.component.html',
    styleUrls: ['./booster.component.scss'],
    standalone: false
})
export class BoosterComponent implements OnInit {

  private _websiteId: number;
  private _websiteUrl: string;
  public testMode: boolean;
  public disconnected: boolean;
  public restNoRoute: boolean;
  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _boosterService: BoosterService,
    private _route: ActivatedRoute,
) {
  }

  ngOnInit() {
    this._initData();
  }

  private _initData(): void {
    this._websiteId = this._route.snapshot.parent.data['website'].id;
    this._websiteUrl = this._route.snapshot.parent.data['website'].site_url;
  }

}
